import {Component, Input} from '@angular/core'

@Component({
  selector: 'dmmp-title',
  templateUrl: './title.component.html',
})
export class TitleComponent {
  @Input() title
  @Input() as_h1
  @Input() class
}
